import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StudentDebtType } from '../../../types/Finance';

const initialState:StudentDebtType = {
  idStudent: '',
  idPaymentType: '',
  originalAmount: 0,
  currentAmount: 0,
  dueDate: '',
  isPayed: false,
  paidDate: '',
  description: '', 
  
}

const studentDebtSlice = createSlice({
  name: "studentDebt",
  initialState,
  reducers: {
    setStudentDebtData:(state, action:PayloadAction<StudentDebtType>)=>({...state, ...action.payload}), 
    resetStudentDebtData :()=>({...initialState})
  }
});

export const {setStudentDebtData,resetStudentDebtData} = studentDebtSlice.actions

export default studentDebtSlice.reducer